import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b0d2494&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=5b0d2494&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=5b0d2494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d2494",
  null
  
)

export default component.exports